// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"b1ca168c","453":"ae230a74","455":"bf3b71b0"}[chunkId] + ".chunk.js";
};